import { useTranslation } from "react-i18next";

export default function ProblemSolution() {
  const { t } = useTranslation();

  const problems = [
    {
      icon: "ri-error-warning-line",
      text: "Chaos danych — brak jednego miejsca na wszystkie informacje",
      image: "https://readdy.ai/api/search-image?query=Cluttered%20desk%20with%20scattered%20papers%20and%20sticky%20notes%2C%20disorganized%20workspace%2C%20messy%20document%20piles%2C%20chaotic%20office%20scene%2C%20warm%20lighting%2C%20editorial%20style%2C%20realistic%20busy%20environment&width=500&height=320&seq=prob-sol-chaos&orientation=landscape",
    },
    {
      icon: "ri-folder-open-line",
      text: "Brak organizacji — trudności w śledzeniu postępów i wyników",
      image: "https://readdy.ai/api/search-image?query=Empty%20filing%20folders%20scattered%20on%20office%20desk%2C%20confused%20person%20silhouette%20in%20background%2C%20lack%20of%20structure%20concept%2C%20warm%20office%20lighting%2C%20editorial%20photography%2C%20professional%20setting&width=500&height=320&seq=prob-sol-organization&orientation=landscape",
    },
    {
      icon: "ri-delete-back-line",
      text: "Utrata informacji — rozproszone dane w różnych miejscach",
      image: "https://readdy.ai/api/search-image?query=Digital%20screens%20showing%20error%20messages%20and%20missing%20data%20icons%2C%20frustrated%20workspace%20concept%2C%20soft%20office%20lighting%2C%20data%20fragmentation%20theme%2C%20editorial%20tech%20photography&width=500&height=320&seq=prob-sol-data-loss&orientation=landscape",
    },
    {
      icon: "ri-bar-chart-grouped-line",
      text: "Trudność śledzenia wyników — brak jasnego obrazu efektywności",
      image: "https://readdy.ai/api/search-image?query=Blurred%20confusing%20charts%20and%20graphs%20on%20multiple%20screens%2C%20unclear%20data%20visualization%2C%20frustrated%20business%20analysis%20concept%2C%20office%20setting%2C%20soft%20warm%20lighting%2C%20editorial%20style&width=500&height=320&seq=prob-sol-tracking&orientation=landscape",
    },
  ];

  const solutions = [
    {
      icon: "ri-check-double-line",
      text: "Wszystkie dane w jednym, centralnym miejscu",
      image: "https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20single%20laptop%20showing%20dashboard%2C%20minimalist%20desk%2C%20everything%20in%20one%20place%20concept%2C%20warm%20natural%20light%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography&width=500&height=320&seq=prob-sol-central&orientation=landscape",
    },
    {
      icon: "ri-stack-line",
      text: "Przejrzysta organizacja z szablonami dla twórców",
      image: "https://readdy.ai/api/search-image?query=Color-coded%20template%20folders%20and%20planner%20on%20minimalist%20desk%2C%20organized%20workflow%20concept%2C%20clean%20workspace%2C%20bright%20natural%20lighting%2C%20productivity%20theme%2C%20editorial%20style&width=500&height=320&seq=prob-sol-templates&orientation=landscape",
    },
    {
      icon: "ri-save-3-line",
      text: "Automatyczne zapisywanie i synchronizacja danych",
      image: "https://readdy.ai/api/search-image?query=Cloud%20sync%20icon%20on%20modern%20laptop%20screen%2C%20automatic%20save%20concept%2C%20clean%20minimalist%20desk%2C%20soft%20ambient%20lighting%2C%20seamless%20technology%20theme%2C%20editorial%20photography&width=500&height=320&seq=prob-sol-autosave&orientation=landscape",
    },
    {
      icon: "ri-line-chart-line",
      text: "Czytelne wykresy i śledzenie wyników w czasie rzeczywistym",
      image: "https://readdy.ai/api/search-image?query=Clean%20dashboard%20showing%20beautiful%20charts%20and%20analytics%20on%20screen%2C%20modern%20office%20desk%2C%20real-time%20tracking%20concept%2C%20warm%20lighting%2C%20professional%20data%20visualization%2C%20editorial%20style&width=500&height=320&seq=prob-sol-charts&orientation=landscape",
    },
  ];

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              Dlaczego twórcy potrzebują USFans Spreadsheet?
            </h2>
            <div className="space-y-4">
              {problems.map((item, idx) => (
                <div key={idx} className="group flex items-start gap-4 p-4 rounded-lg bg-background-100/70 border border-background-200/50 hover:shadow-md transition-all duration-300 cursor-pointer">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={item.image}
                      alt=""
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-base text-primary-500`}></i>
                      </div>
                      <p className="text-sm text-foreground-700">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              Jak USFans Spreadsheet pomaga zarządzać danymi?
            </h2>
            <div className="space-y-4">
              {solutions.map((item, idx) => (
                <div key={idx} className="group flex items-start gap-4 p-4 rounded-lg bg-accent-50/70 border border-accent-200/50 hover:shadow-md transition-all duration-300 cursor-pointer">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={item.image}
                      alt=""
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-base text-accent-600`}></i>
                      </div>
                      <p className="text-sm text-foreground-700">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}